import React, { useEffect, useRef, useState } from 'react'
import useGlobalLoader from '../../configurations/useGlobalLoader';

export default function GlobalLoader() {
    const { loading } = useGlobalLoader()
    const [count, setCount] = useState(0);
    const [refresh, setRefresh] = useState(0);

    useEffect(() => {
        if (loading) {
            if (count === 0)
                setRefresh(pre => pre + 1)
        }
    }, [count])

    useEffect(() => {
        var i = 0
        if (loading) {
            let tic = setInterval(function increment() {
                if (i < 100) {
                    i = i + 1;
                }
                else {
                    clearInterval(tic)
                    i = 0
                }
                setCount(i);
            }, 10);
        }
        else {
            i = 0
        }
    }, [loading, refresh])



    return (
        <>
            <div id='gLoading' style={{ width: count + "%" }} class={`h-[2px] mt-[60px] bg-brand-400 absolute z-40 top-0 `}></div>
        </>
    )
}
//w-[${count}%]